import { withRouter } from 'react-router-dom';

import { ProductCard } from 'Component/ProductCard/ProductCard.component';

import './ProductCardWishlist.style.scss';

/** @namespace Pwa/Component/ProductCardWishlist/Component */
export class ProductCardWishlist extends ProductCard {
    renderCardContent() {
        const { removeButton } = this.props;

        return (
            <>
                {this.renderDiscountLabel()}
                <div block="ProductCard" elem="LabelsWithActions">
                    <div block="ProductCard" elem="Labels">
                        {this.renderLabels()}
                    </div>
                    {removeButton}
                </div>
                {this.renderCardLinkWrapper(
                    <>
                        <div block="ProductCard" elem="FigureReview">
                            <figure block="ProductCard" elem="Figure">
                                {this.renderPicture()}
                            </figure>
                            <figure block="ProductCard" elem="FigureAlternative">
                                {this.renderAlternativePicture()}
                            </figure>
                        </div>
                        <div block="ProductCard" elem="Content">
                            <div block="ProductCard" elem="Price">
                                {this.renderPrice()}
                            </div>
                            {this.renderName()}
                        </div>
                    </>
                )}
                <div block="ProductCard" elem="Content">
                    {this.renderConfigurableOptions()}
                    {this.renderAddToCartField()}
                </div>
            </>
        );
    }
}

export default withRouter(ProductCardWishlist);
